import form from "layouts/pages/roles-and-permissions/schemas/form";

const {
  formField: { roleName, userType, description, status },
} = form;

const initialValues = {
  [roleName.name]: "",
  [userType.name]: "tenant",
  [description.name]: "",
  [status.name]: "active",
};

export default initialValues;
